import { useState } from 'react';
import { Link } from 'react-router-dom';
import { createProductUrl } from '../../utils/paths';

export default function ProductItem({ product }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Handle missing images
  const hasImages = product.images && product.images.length > 0;
  const currentImage = hasImages ? product.images[currentImageIndex] : null;

  return (
    <Link to={createProductUrl(product.id, product.name)} key={'product_' + product.id} className="product-card">
      <div className="product-image">
        {hasImages ? (
          <img 
            src={currentImage.url} 
            alt={product.name} 
          />
        ) : (
          <div className="product-image-placeholder">
            <span>No Image</span>
          </div>
        )}
        {hasImages && product.images.length > 1 && (
          <div className="product-image-dots">
            {product.images.map((_, index) => (
              <span
                key={index}
                className={`product-dot ${index === currentImageIndex ? 'active' : ''}`}
                onMouseEnter={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        )}
      </div>
      <div className="product-info">
        <div className="product-name">{product.name}</div>
        <div className="product-price">
          {product.order_only ? (
            <span className="product-badge-order-only">Order Only</span>
          ) : product.coming_soon ? (
            <span className="product-badge-coming-soon">Coming Soon</span>
          ) : (
            <>
              {product.price.curr} {product.price.amount}
            </>
          )}
        </div>
      </div>
    </Link>
  );
}
